<template>
  <div class="login-container">
    <div class="login-form">
      <h1>Login</h1>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="username">Usuário:</label>
          <input id="username" v-model="form.username" type="text" required class="form-input" />
        </div>

        <div class="form-group">
          <label for="password">Senha:</label>
          <input id="password" v-model="form.password" type="password" required class="form-input" />
        </div>

        <button type="submit" class="btn-login" :disabled="loading">
          {{ loading ? 'Entrando...' : 'Entrar' }}
        </button>

        <div v-if="error" class="error-message">
          {{ error }}
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import api from '../services/api'

export default {
  name: 'LoginPage',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      loading: false,
      error: ''
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true
      this.error = ''

      try {
        const response = await api.post('/auth/login', {
          username: this.form.username,
          password: this.form.password
        })

        if (response.data.success) {
          localStorage.setItem('token', response.data.token)
          localStorage.setItem('isSuperUser', response.data.isSuperUser)
          localStorage.setItem('username', response.data.username)
          this.$router.push('/admin')
        } else {
          this.error = 'Credenciais inválidas'
        }
      } catch (error) {
        console.error('Erro ao fazer login:', error)
        this.error = error.response?.data?.message || 'Erro ao fazer login'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
}

.login-form {
  background: #ffffff;
  padding: 2rem;
  border: 2px solid #000000;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.login-form h1 {
  text-align: center;
  color: #000000;
  margin-bottom: 2rem;
  font-family: 'Roboto', sans-serif;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #000000;
  font-weight: 500;
}

.form-input {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #000000;
  border-radius: 4px;
  font-size: 1rem;
  background-color: #ffffff;
  color: #000000;
}

.form-input:focus {
  outline: none;
  border-color: #333333;
}

.btn-login {
  width: 100%;
  padding: 0.75rem;
  background-color: #000000;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-login:hover:not(:disabled) {
  background-color: #333333;
}

.btn-login:disabled {
  background-color: #666666;
  cursor: not-allowed;
}

.error-message {
  margin-top: 1rem;
  padding: 0.75rem;
  background-color: #ffebee;
  color: #c62828;
  border: 1px solid #ffcdd2;
  border-radius: 4px;
  text-align: center;
}
</style>
